import React from 'react'
import { useTranslation } from 'react-i18next'
import Card from '../../ui/Card'

const PlatformInfo = ({ platformData }) => {
  const { t } = useTranslation()

  if (!platformData) {
    return (
      <div className="animate-pulse">
        <div className="h-64 bg-gray-200 rounded-lg mb-4"></div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-32 bg-gray-200 rounded-lg"></div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        {/* 平台信息 */}
        <Card className="mb-12">
          <div className="p-8">
            <div dangerouslySetInnerHTML={{ __html: platformData.content }} />
            
            {/* {platformData.createTime && (
              <div className="mt-6 text-right text-gray-500 text-sm">
                更新时间: {platformData.createTime}
              </div>
            )} */}
          </div>
        </Card>
      </div>
    </section>
  )
}

export default PlatformInfo 